<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-row class="add-btn">
			<el-button type="primary" style="margin-right:40px;" icon="el-icon-circle-plus-outline" @click="add_dv1=true">添加</el-button>
		</el-row>
		<el-table :data="platList" border style="width: 100%">
			<el-table-column prop="id" label="id" width="80">
			</el-table-column>
			<el-table-column prop="ip" label="地址">
			</el-table-column>
			<el-table-column prop="host" label="端口号">
			</el-table-column>
			<el-table-column prop="name" label="平台名称">
			</el-table-column>
			<el-table-column prop="areaName" label="所在地市">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleEdit( scope.row)" icon="el-icon-edit">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
		<!-- 查看 :dialogUserInfo名字随便-->
		<el-dialog :title="dialogUserInfo.nickname+'的资料'" :visible.sync="detail_dv" width="30%">
			<plat-detail :dialogUserInfo="dialogUserInfo" :detail_loading="detail_loading"></plat-detail>
		</el-dialog>
		<!-- 编辑平台列表 -->
		<el-dialog title="编辑平台列表" :visible.sync="add_dv" width="30%">
			<add-plat ref="addPlatListForm"></add-plat>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_dv = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 添加平台列表 -->
		<el-dialog title="添加平台列表" :visible.sync="add_dv1" width="30%" @close="clearAddModel">
			<add ref="addPlatListForm1"></add>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_dv1 = false">取 消</el-button>
				<el-button type="primary" @click="addUser1">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import addPlat from "./plat-detail/add_plat.vue"
	import add from "./plat-detail/add.vue"
	import mybread from "@/components/bread"

	export default {
		components: {
			addPlat,
			add,
			mybread
		},
		inject: ['reload'],
		data() {
			return {
				detail_dv: false,
				detail_loading: false,
				dialogUserInfo: [],
				add_dv: false,
				add_dv1: false,
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				platList: [],
				list_loading:true
			}
		},
		watch: {
			pageTotal() {
				if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) {
					this.currentPage -= 1;
					this.getPlatList(); //获取列表数据
				}
			}
		},

		created() {
			this.getPlatList()
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getPlatList();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getPlatList();
			},
			getPlatList() { //获取数据
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/platform/listData", data).then(res => {
					this.platList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
				}).catch((e) => {
					window.console.log(e)
				})

			},

			handleEdit(row) { //编辑
				this.isEdit = true
				this.add_dv = true
				this.$post("api/platform/detail/"+row.id).then(res => {
					this.$refs.addPlatListForm.form = res.data
				}).catch((e) => {
					window.console.log(e)
				})

			},

			handleDelete(row) { //删除
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post("api/platform/delete/" + row.id).then(res => {
						let totalPage = Math.ceil((this.total - 1) / this.pageSize)
						let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage
						this.currentPage = currentPage < 1 ? 1 : currentPage
						
						var isSuccess = res.success
						if (isSuccess == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getPlatList()
						}
					}).catch((e) => {
						window.console.log(e)
					})

				})
			},
			addUser() { //编辑确定
				this.$refs.addPlatListForm.$refs.frmAdd.validate((valid) => {
					if (valid) {
						const data = {
							id: this.$refs.addPlatListForm.form.id,
							name: this.$refs.addPlatListForm.form.name,
							ip: this.$refs.addPlatListForm.form.ip,
							host: this.$refs.addPlatListForm.form.host,
							areaName: this.$refs.addPlatListForm.form.areaName
						}
						this.$post("api/platform/update", data).then(res => {
							var isSuccess = res.success
							if (isSuccess == 1) {
								this.$message({
									message: '保存成功！',
									type: 'success'
								});
								this.getPlatList()
							} else {
								this.$message({
									message: '保存失败！',
									type: 'error'
								});
							}
							this.add_dv = false
						}).catch((e) => {
							window.console.log(e)
						})

					} else {
						return this.$message({
							message: '请完整填写信息！',
							type: 'warn'
						})
					}
				})
			},
			addUser1() { //添加确定
				this.$refs.addPlatListForm1.$refs.frmAdd.validate((valid) => {
					if (valid) {
						let data = {
							ip:this.$refs.addPlatListForm1.form.ip,
							host:this.$refs.addPlatListForm1.form.host,
							name: this.$refs.addPlatListForm1.form.name,
							areaName:this.$refs.addPlatListForm1.form.areaName
						}
						this.$post("api/platform/add", data).then(res => {
							var isSuccess = res.success
							if (isSuccess == 1) {
								this.$message({
									message: '保存成功！',
									type: 'success'
								});
								this.getPlatList()
							} else {
								this.$message({
									message: '保存失败！',
									type: 'error'
								});
							}
							this.add_dv1 = false
						}).catch((e) => {
							window.console.log(e)
						})

					} else {
						// window.console.log("error submit!!!");
						return this.$message({
							message: '请完整填写信息！',
							type: 'warn'
						})
					}
				})
			},
			clearAddModel() { //返回时清空表单数据
				this.$refs.addPlatListForm1.form = {
					ip: "",
					name: "",
					host: "",
					areaName: ""
				}
			},

		}
	}
</script>

<style scoped="scoped">
	.add-btn {
		margin-bottom: 20px;
	}

	.add-btn .el-button {
		font-size: 16px;
	}

	.block {
		text-align: center;
		margin-top: 20px;
	}

	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}
</style>
